import {Component, Inject, Vue} from "vue-property-decorator";
import {MainContainer} from "~/components/main-container";
import {PageTitle} from "~/components/page-title";
import {UsersNavigationTabs, UsersTab} from "~/modules/users/compponents/navigation-tabs";
import {UsersList} from "~/modules/users/compponents/users-list";
import {UsersByGroupsList} from "~/modules/users/compponents/users-groups-list";
import {Getter, namespace} from "vuex-class";
import {icons} from "~/components/icon";
import {Loader} from "~/components/loader";
import {AppSettings} from "~/lib/app-settings";

const usersManagementStore = namespace("usersManagement");

@Component
export class UsersView extends Vue {

  @Inject() appSettings: AppSettings;
  @Getter currentUser;

  @usersManagementStore.Action fetchUsersManagementData;
  @usersManagementStore.Action fetchUsers;

  private isLoading = false;
  private currentTab: UsersTab = UsersTab.UsersList;

  async created(){
    this.isLoading = true;
    await Promise.all([
      this.fetchUsersManagementData(this.appSettings.clientUUID)
    ]);
    this.isLoading = false;
  }

  renderContent() {
    if (this.isLoading) return <Loader/>;
    switch (this.currentTab) {
      case UsersTab.UsersList :
        return <UsersList/>;
      case UsersTab.Groups :
        return <UsersByGroupsList/>;
    }
  }

  render() {
    return (
      <MainContainer>
        <PageTitle icon={icons.allUsers} title={"Comptes utilisateurs"}/>
        <UsersNavigationTabs  v-model={this.currentTab} />
        <div class="page-content">
          {this.renderContent()}
        </div>
      </MainContainer>
    );
  }
}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-032d9e08/users-view.tsx" });